import { useParams } from 'react-router-dom';
import FeaturePage from './FeaturePage';
import AIAgentsFeaturePage from './AIAgentsFeaturePage';
import { features } from './data';
import NotFound from '../NotFound';

export default function FeatureRoute() {
  const { slug } = useParams<{ slug: string }>();

  if (!slug || !features[slug]) {
    return <NotFound />;
  }

  const data = features[slug];
  if (slug === 'ai-agents') {
    return <AIAgentsFeaturePage data={data} />;
  }

  return <FeaturePage data={data} />;
}
